export default [
  {
    type: 'subtitle',
    content: 'شروط وأحكام العميل',
  },
  {
    type: 'subtitle',
    content: 'تمارا',
  },
  {
    type: 'text',
    content: 'مرحبًا،',
  },
  {
    type: 'text',
    content:
      'أهلاً بك، نحن تمارا. يمكنك باستخدام تطبيق الجوال أن تستمتع بتجربة تسوق لدى بعضٍ من تجار التجزئة المفضلين لديك وذلك بأن تختار إحدى خدمات تمارا عند الدفع.',
  },
  {
    type: 'subtitle',
    content: 'كيفية التواصل',
  },
  {
    type: 'text',
    content:
      'إذا أردت التواصل معنا بشأن خدمات تمارا، يُرجى الاتصال بمركز مساعدة العملاء لدى تمارا.',
  },
  {
    type: 'text',
    content:
      'إذا كان لديك حساب تمارا، لا تنسَ مراجعة رسائل البريد الإلكتروني والرسائل النصية التي تتلقاها عبر حساب تمارا الخاص بك إذ هي الوسيلة المعتادة لنتواصل معك في كل ما يخص حسابك.',
  },
  {
    type: 'text',
    content:
      'لقد قسمنا شروط وأحكام العميل إلى أقسامٍ يسيرة الاطلاع، وذلك على النحو التالي:',
  },
  {
    type: 'text',
    content:
      '<strong>القسم الأول – المقدمة</strong> – وينص على الغرض من هذه الشروط والكيفية التي يمكننا بها (كتمارا) إجراء التعديلات اللازمة على الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>القسم الثاني – استخدامك لخدمات تمارا</strong> – وينص على الالتزامات والقواعد ذات الصلة باستخدامك لخدمات تمارا، ومن ذلك ما يتعلق بالدفع.',
  },
  {
    type: 'text',
    content:
      '<strong>القسم الثالث – الشروط العامة </strong>– ويتضمن مجموعةً من الالتزامات بينك كعميل وبيننا كتمارا، ومن ذلك (على سبيل المثال لا الحصر) ما يتعلق بكيفية تعاملنا مع البيانات الشخصية، ومسؤوليتنا تجاهك إذا حدث خطأ ما، والنظام الساري على هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>القسم الرابع – التعريفات </strong> – ويتضمن تعريفات لأية مصطلحات واردة في هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      'نوصيك بقراءة هذه الشروط والأحكام بعناية لتُلِمَّ بها وتفهمَ طريقة عمل خدمات تمارا.',
  },
  {
    type: 'subtitle',
    content: 'القسم الأول – المقدمة',
  },
  {
    type: 'subtitle',
    content: ' ١. مقدمة',
  },
  {
    type: 'text',
    content:
      '<strong>١.١.</strong> تشكل هذه الشروط والأحكام اتفاقية مُلزِمَة نظامًا بينك (إما شخصيًا أو نيابة عن كيان تمثله) وشركة تمارا م.م.ح ("تمارا")، ويشار إليها هنا فيما بعد بـ "نحن"، فيما يتعلق بجميع جوانب خدمات تمارا و/أو استخدامك لتطبيق الجوال أو وصولك إلى الموقع الإلكتروني، بالإضافة إلى أي قناة وسائط أو موقع إلكتروني أو تطبيق جوال متعلق أو مرتبط بهما، وذلك من خلال وصولك إلى تطبيق الجوال أو الموقع الإلكتروني أو استخدامك لأي منهما. وأنت تقرُّ بأنك قد قرأت هذه الشروط والأحكام وفهمتها ووافقت على الالتزام بها، بصيغتها المعدلة من وقت لآخر. وإذا كنت لا توافق على هذه الشروط والأحكام، فعليك التوقف فورًا عن استخدام أو الوصول إلى خدمات تمارا و/أو تطبيق الجوال و/أو الموقع الإلكتروني. وإذا كنت تستخدم تطبيق الجوال أو الموقع الإلكتروني نيابة عن الغير، ومن ذلك مثلاً أي كيان تجاري، فأنت تتعهد بأنك مفوض ولديك سلطة إلزام ذلك الغير بهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢.</strong>  لا يعد التاجر الذي تشتري منه السلع أو الخدمات باستخدام خدمات تمارا طرفًا في هذه الشروط والأحكام، وأي شروط منطبقة بينك وبين التاجر إنّما هي منفصلة عن هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>١.٣.</strong>  نحتفظ بحقنا − وفقًا لتقديرنا المطلق − في إجراء تغييرات أو تعديلات على هذه الشروط والأحكام في أي وقت ولأي سبب، ومن ذلك أية شروط وأحكام أخرى تُنشر على الموقع الإلكتروني أو تطبيق الجوال من وقت لآخر، بالإضافة لتلك المشار إليها في البند (12) أدناه.  وسنقدم لك إخطارًا مدته ثلاثون (30) يوماً بأي تغيير يطرأ على هذه الشروط والأحكام (ما لم تجِز الأنظمة السارية أو تقتضِ غير ذلك) عبر وسائل الاتصال المتفق عليها كما هو موضح أدناه.',
  },
  {
    type: 'text',
    content:
      '<strong>١.٤.</strong>  إذا واصلت استخدام الموقع الإلكتروني و/أو تطبيق الجوال، ومن ذلك خدمات تمارا ذات الصلة بالتعديل، وذلك بعد إبلاغك بالشروط والأحكام المعدلة، فإن ذلك يشكل إقرارًا منك بأنك قد قرأت التعديلات والتغييرات وفهمتها ووافقت عليها.',
  },
  {
    type: 'subtitle',
    content: 'القسم الثاني - استخدامك لخدمات تمارا',
  },
  {
    type: 'subtitle',
    content: ' ٢. الأهلية والصلاحية',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١.</strong>  إذا استخدمت خدمات تمارا، فإنك بذلك تتعهد وتُقِرّ بأنك تتمتع بالأهلية النظامية لإبرام هذه الشروط والأحكام، وأن عمرك يتجاوز حَدّ الثمانية عشر (18) عامًا، وأنك سوف تستخدم الخدمات بصفتك الشخصية وبوسائل الدفع الخاصة بك والمسجلة باسمك في جميع الأوقات.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٢.</strong>  إذا نقرت فوق الموافقة على هذه الشروط والأحكام، فإنك تُقِرّ بأنك قبلت هذه الشروط والأحكام وأبرمتها إلكترونيًا.',
  },
  {
    type: 'subtitle',
    content: ' ٣. الحسابات والتسجيل',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١.</strong>  تتطلب عملية تسجيل حساب تمارا منك تزويد تمارا بمعلومات شخصية معينة لأغراض (1) إنشاء حساب تمارا، و(2) تقديم أي من خدمات تمارا لك، و(3) الامتثال للأنظمة السارية، ومن ذلك مثلاً الامتثال لالتزامات "اعرف عميلك". وقد تتضمن هذه المعلومات اسمك الكامل وعنوانك وبريدك الإلكتروني ورقم الهاتف وعمرك. وأنت تُقِرّ وتوافق على أن أية معلومات شخصية مقدمة من قبلك هي صحيحة ودقيقة وكاملة ومحدثة. وإذا طرأ أي تغيير على هذه المعلومات الشخصية أو أي معلومات وظروف أخرى قد تؤثر على أهليتك للاستمرار في استخدام خدمات تمارا أو كان هذا التغيير مطلوبًا على نحو آخر بموجب هذه الشروط والأحكام، فإنه يجب عليك إخطار تمارا بذلك التغيير على الفور.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٢.</strong>  أنت توافق بموجب هذه الشروط والأحكام على الإفصاح عن جميع التزاماتك المالية، وذلك بِناءً على طلب تمارا أو أيٍّ من وكلائها أو مقاوليها من الباطن، والامتناع عن حجب أية معلومات قد تكون مؤثرة أو مهمة لأيٍّ من الأطراف المعنية بتقديم خدمات تمارا لك.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٣.</strong>  أنت توافق بموجب هذه الشروط والأحكام على أنك ستكون مسؤولاً عن أي نشاط تحت حساب تمارا الخاص بك، كما تلتزم بالحفاظ باستمرار على وجود تدابير أمنية مناسبة لحماية تفاصيل حسابك.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٤.</strong>  إذا فقدت كلمة المرور الخاصة بك أو سُرِقَت منك، أو إذا كنت تعتقد أن ثمّة وصولاً غير مصرح به إلى حساب تمارا الخاص بك، فيجب عليك تغيير كلمة المرور لحساب تمارا الخاص بك وإخطارنا بذلك على الفور. وتتحمل أنت المسؤولية عن أي من المعاملات التي تُجرى باستخدام بيانات حساب تمارا المسروقة ما لم تخطرنا على الفور بإيقاف الحساب مؤقتًا، وتتلقى رسالة من تمارا تفيد بأن حساب تمارا الخاص بك قد تقرر إيقافه مؤقتًا أو إلغاؤه.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٥.</strong>  لا يجوز لك مشاركة بيانات حساب تمارا الخاص بك مع أي شخص آخر. وأنت تُقِرّ وتوافق على رد قيمة أي معاملة أُجريَت باستخدام حساب تمارا الخاص بك إلى تمارا تكون قد طلبتها أنت أو أي شخص آخر وصل إلى خدمات تمارا من خلال استخدام اسم المستخدم أو كلمة المرور الخاصة بك، سواء سمحت بذلك الوصول أم لم تسمح به. كما تُقرّ وتوافق على أن تمارا تحتفظ بالحق في إلغاء أي معاملة إذا تبين أنك شاركت بيانات حساب تمارا الخاص بك مع أي شخص آخر.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٦.</strong>  يجب عليك إخطار تمارا على الفور بأي نشاط احتيالي أو غير نظامي مشتبه به أو فعلي تَحَدَّدَ نتيجة لاستخدامك لخدمات تمارا (ومن ذلك ما يتعلق بأي فعل أو إغفال من جانب أي تاجر). فإذا لم تنفذ ذلك، فإن هذا قد يؤدي إلى إيقاف أو إلغاء حساب تمارا الخاص بك، بالإضافة إلى أي إجراء نظامي إضافي آخر تتخذه تمارا وفقًا لتقديرها المطلق. وإذا تبين وجود نشاط احتيالي أو غير نظامي فعلي أو مشتبه به يعزى إلى تاجر أو منصة تاجر تستخدم خدمات تمارا، فعليك إبلاغ تمارا على الفور عن هذا التاجر أو منصة التاجر (حسب الاقتضاء) قبل اتخاذ أي إجراء آخر.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٧.</strong>  إذا شكّت تمارا − وفقًا لتقديرها المطلق − في أن أيًا من المعلومات التي قدمتها غير صحيحة أو غير دقيقة أو غير كاملة أو غير مُحَدَّثَة، فإنّه يحق لتمارا إيقاف أو تقييد الوصول إلى خدمات تمارا و/أو تطبيق الجوال و/أو الموقع الإلكتروني، وهذا دون الإخلال بأي حقوق أو سبل انتصاف أخرى، وفقًا لهذه الشروط والأحكام أو وفقًا للأنظمة السارية.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٨.</strong>  يجوز لتمارا − وفقًا لتقديرها المطلق – القيام بأي استفسارات تراها ضرورية (سواء بشكل مباشر أو من خلال الغير، ومن ذلك مثلاً أي وكالة ائتمانية)، وأن تطلب منك تقديم مزيد من المعلومات أو الوثائق حسب الضرورة. وأنت تُقِرّ وتوافق على تزويد تمارا بأيّة معلومات و/أو وثائق عند الطلب. كما تُقرُّ وتوافق على أنه إن لم تقم بذلك، يجوز لتمارا − دون أن تتحمل أية مسؤولية − تقييد أو إيقاف أو سحب وصولك إلى خدمات تمارا أو تطبيق الجوال أو الموقع الإلكتروني. وتحتفظ تمارا بحقها في إلغاء أي حسابات لم يجرِ التأكد أو التحقق من صحتها أو حسابات لم تكن نشطة لفترة من الزمن؛ وفقًا لتقديرها المطلق.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٩.</strong>  عند الانتهاء من عملية التسجيل، فإنك تُقِرّ وتوافق على أنك قد قرأت هذه الشروط والأحكام وفهمتها وتوافق على الالتزام بها. وتُعَدّ هذه الشروط والأحكام متضمنة سياسة خصوصية تمارا المتوفرة في الموقع الإلكتروني بحسب أي تحديثات لها من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٠.</strong>  إذا رُفض طلبك فيما يتعلق بالحصول على حساب تمارا أو أي من خدمات تمارا، فسنبلغك بسبب هذا الرفض في غضون خمسة (5) أيام أو بحسب أي فترة زمنية أخرى تقتضيها الأنظمة السارية، أيهما أطول مدة.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١١.</strong>  أنت توافق على التعاون مع تمارا وتقديم كل المساعدة المعقولة لتمكيننا من الامتثال لالتزاماتنا التنظيمية أو حسبما يكون ذلك مطلوبًا من قبل أي جهة تنظيمية ذات صلة.',
  },
  {
    type: 'subtitle',
    content: '٤. خدمات تمارا',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١.</strong> تمارا هي شركة تمويل تقدم للعملاء مجموعة متنوعة من طرق الدفع والتمويل عند شراء سلع أو خدمات من خلال العديد من التجار أو منصات التجار.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٢.</strong> يعرض الموقع الإلكتروني وتطبيق الجوال قائمة بالتجار المستقلين الذين يقبلون تمارا كخيار دفع وتمويل؛ بحسب أي تحديث من وقت لآخر. وقد أَبرَم هؤلاء التجار اتفاقيات مُلزِمَة لتقديم هذه المُنتَجات أو الخدمات من خلال مواقع التجار الإلكترونية أو تطبيقاتهم أو المنصات الخاصة بالتجار.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٣.</strong> الامتثال لأحكام الشريعة الإسلامية: تلتزم تمارا بأحكام الشريعة الإسلامية في كل معاملاتها طبقًا للقرارات الصادرة عن اللجنة الشرعية بتمارا، ولا تفرض تمارا أية فوائد أو غرامات على المدفوعات المتأخرة.',
  },
  {
    type: 'subtitle',
    content: ' ٥. التواصل الإلكتروني',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١.</strong> إذا أنشأت حساب تمارا، فإنك بذلك تُقِرّ وتوافق على أنك ستتواصل معنا إلكترونيًا. وبالتالي، فإنك توافق على أنه يجوز لتمارا تقديم جميع المراسلات وبيانات الدفع والشروط والأحكام والمعلومات المطلوب منا تقديمها بموجب النظام وجميع المراسلات المتعلقة بأية شكاوى وأية معلومات أخرى إليك إلكترونيًا على عنوان البريد الإلكتروني الذي قدمته إلينا.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٢.</strong>  لضمان قدرتنا على التواصل معك إلكترونيًا، فإنك توافق على أنه من مسؤوليتك إخطارنا على الفور بأي تغيير في عنوان بريدك الإلكتروني ورقم جوّالك أو أيّة معلومات أخرى تقدمها لنا. ويجوز لنا أن نتصل بك من حين لآخر لطلب تحديث لهذه المعلومات وأيّة معلومات أخرى متعلقة بحساب تمارا الخاص بك.',
  },
  {
    type: 'subtitle',
    content: ' ٦. حقوق الملكية الفكرية',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١.</strong>  أنت تُقِرّ بأن جميع حقوق الملكية الفكرية على الموقع الإلكتروني و/أو تطبيق الجوال (حسب الاقتضاء)؛ تؤول ملكيتها تلقائيًا إلى تمارا أو الجهات المرخِّصة لها أو التجار الخارجيين، وذلك إلى أقصى حد يجيزه النظام.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٢.</strong>  يُعَدّ شعار تمارا والرموز المرتبطة به علامات تجارية مملوكة لتمارا، ولا يجوز استخدام علامات تمارا التجارية فيما يتعلق بأي مُنتَجات أو خدمات لا تقدمها تمارا، ومن ذلك أي مُنتَجات أو خدمات تنتقص من قَدر تمارا أو تضر بسمعتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٣.</strong>  يُحظر عليك استخدام أي علامة تجارية أو أي حقوق ملكية فكرية تخص تمارا، من أي جزء من خدمات تمارا، ويُحظر عليك استنساخ أو تعديل خدمات تمارا أو إجراء أية عملية إعداد أو نشر أو تنفيذ أو إرسال أو عرض أو بَثّ أو أي وسيلة أخرى لاستغلال خدمات تمارا ما لم تسمح تمارا بذلك أو تأذن به صراحةً بصورة خطية. كما لا يجوز لك نَسخ أو فَك تجميع أو إجراء هندسة عكسية أو تفكيك أو محاولة اشتقاق رمز مصدري أو فك تشفير أو تعديل أو إنشاء أعمال مشتقة من خدمات تمارا أو أي جزء منها، وتوافق على عدم تمكين الآخرين من ذلك أيضًا (إلا بقدر ما يكون أي قيد من القيود المذكورة آنفًا محظورًا بموجب الأنظمة السارية).',
  },
  {
    type: 'subtitle',
    content: '٧. استخدام الموقع الإلكتروني وتطبيق الجوال',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١.</strong>  يُحظر عليك استخدام الموقع الإلكتروني و/أو تطبيق الجوال لنشر أي من المحتوى التالي: أي استخدام للغة بذيئة أو فاحشة أو إهانات أو إساءة ثقافية أو دينية أو أي محتوى سياسي أو نقدي أو أي مادة قد تهدد المصلحة العامة أو الأمن الوطني أو تتسبب في التشهير أو التطاول أو القذف أو أي محتوى آخر قد يكون مسيئًا أو فاحشًا أو غير لائق.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.٢.</strong> نحتفظ بالحق في إنهاء علاقتك بنا وإلغاء وصولك إلى خدمات تمارا بقدر ما تنشر للعامة (ومن ذلك مثلاً ما يكون على وسائل التواصل الاجتماعي) أي محتوى يتعلق بتمارا يكون فاحشًا أو بذيئًا أو غير لائق أو مسيئًا.',
  },
  {
    type: 'subtitle',
    content: '٨. قوائم المنتجات ومدى توافرها',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١.</strong> أنت تدرك أن تمارا مجرد شركة تمويل، ولا تتحمل أية مسؤولية عن تصنيع أو شحن أو إنتاج أو تسليم أي من المُنتَجات أو الخدمات المشتراة عبر تمارا.  وعلى ذلك، لا تكون تمارا مسؤولة عن توافر أو جودة أو أي جانب آخر يتعلق بأي مُنتَجات معروضة على موقع التاجر أو تطبيقه أو منصة التاجر.',
  },
  {
    type: 'subtitle',
    content: '٩. خدمة ما بعد البيع للمنتجات',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١.</strong> لا تكون تمارا مسؤولة عن أي مُنتَجات أو خدمات تُباع من خلال أي مواقع إلكترونية أو تطبيقات خاصة بالتاجر أو من خلال منصات التاجر. ويكون المسؤول عن توفير هذه المُنتَجات والخدمات ودعمها هم التجار أو مصنعو هذه المُنتَجات والخدمات أو موزعيها المحليين دون سواهم، فضلاً عن مورديها، وذلك وفقًا للشروط والأحكام المرتبطة بكل مُنتَج أو خدمة. وتستبعد تمارا صراحةً أي ضمان من أي نوع للمُنتَجات أو الخدمات المباعة على المواقع الإلكترونية والتطبيقات الخاصة بالتجار أو على منصات التجار. ويجب توجيه أي طلبات دعم فني أو خدمة عملاء أو خدمة ما بعد البيع فيما يتعلق بالمُنتَجات أو الخدمات إلى التاجر ذي الصلة.',
  },
  {
    type: 'subtitle',
    content: '١٠. الدفع',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١.</strong> عندما تنشئ حساب تمارا وفقًا لهذه الشروط والأحكام، فإنك ستتمكن بعدئذ من الوصول إلى خدمات تمارا عندما تختار الدفع مقابل السلع أو الخدمات باستخدام خيار الدفع والتمويل من خلال خدمات تمارا لدى التاجر ذي الصلة أو على منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٢.</strong> تتيح لك خدمات تمارا شراء سلع أو خدمات من تاجر أو منصة تاجر. فعندما تختار إحدى خيارات الدفع والتمويل التي توفرها تمارا، فقد تنطبق شروط وأحكام مختلفة بالإضافة إلى هذه الشروط والأحكام، وقد تُحَصِّل تمارا رسومًا يتعين عليك دفعها لاحقًا وفق ما يسمح به النظام الساري. وتُعدُّ هذه الشروط والأحكام مدرجة ضمن تلك الشروط والأحكام الإضافية، ما لم يرد خلاف ذلك في الشروط والأحكام السارية.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٣.</strong> سنبذل قصارى جهدنا − متى وسِعنا ذلك − لتوجيهك إلى أي شروط وأحكام منفصلة تكون متاحة على الموقع الإلكتروني، إلا أنّك المسؤول دومًا عن التحقق من وجود مثل هذه الشروط والأحكام. كما سنسعى دائمًا إلى إبلاغك بأية رسوم مرتبطة بأي من خدمات تمارا عند اختيارها، غير أنّك المسؤول دومًا عن التحقق من الرسوم المطبقة من على الموقع الإلكتروني.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٤.</strong> أنت مسؤول عن فهم جميع الرسوم المرتبطة بطلب الشراء الخاص بك وقبول هذه الرسوم على النحو المقرر أثناء عملية الدفع والتمويل. وإذا كان هناك أي مبلغ مستحق، فإنك تتعهد بدفعه إلى تمارا وفقًا لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٥.</strong> عندما تختار خدمات تمارا عند نقطة البيع الخاصة بالتاجر، سيُطلب منك بعدئذ اختيار طريقة الدفع والتمويل والتي ستصبح سارية وملزمة بينك وبين تمارا فيما يتعلق بطلب الشراء.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٦.</strong> يحق لك طلب نسخة من الاتفاقية الكاملة التي أبرمتها معنا في أي وقت، وعندئذ نكون ملزمين بإتاحتها لك في غضون خمسة (5) أيام عمل من تاريخ الطلب، أو أي فترة زمنية أخرى تقتضيها الأنظمة السارية، أيهما يأتي لاحقًا، وهذا يشمل الحالات التي لا تكون فيها هذه المعلومات متاحة بالفعل عبر الموقع الإلكتروني و/أو تطبيق الجوال. ويحق لك أيضًا طلب أي كشوف حساب عن أي معاملات ذات صلة (تتضمن جميع الرسوم والتكلفة المتكبدة خلال فترة زمنية محددة وجميع الرسوم الإضافية، في حالة التخلف عن السداد) على أساس ربع سنوي.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٧.</strong> أنت تُقِرّ بأنّك تتحمل المسؤولية الكاملة عن أي طلب شراء أو معاملة، بغض النظر عما إذا كانت السلع أو الخدمات ذات الصلة قد تسلمتها أو قُدِّمَت إليك بنجاح (حسب الاقتضاء).',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٨.</strong> أنت تقر وتوافق على أنّه لكي تُتمَّ معاملة باستخدام خدمات تمارا، فيجب أن تكون لديك وسيلة واحدة على الأقل مناسبة للسداد، مثل بطاقة ائتمانية أو بطاقة خصم، مضافة إلى حساب تمارا الخاص بك، وتكون مسجلة في الحساب باستمرار (وتُعرف باسم "البطاقة المسجلة"). وهذا يعني أنّ البطاقة المسجلة الحالية الخاصة بك لو انتهت صلاحيتها أو استُبدلت أو لم تعد راغبًا في استخدامها كوسيلة للسداد، فلن تتمكن من حذفها من حساب تمارا الخاص بك إلا إذا أضفت بطاقة مسجلة بديلة وحتى تضيف مثل هذه البطاقة البديلة. وأنت تقر بأنك لو لم توفر بطاقة مسجلة سارية، فإن هذا سيؤثر على قدرتك على إتمام أي معاملة بنجاح.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٩.</strong> تحتفظ تمارا بحقّها في إجراء أي تغيير أو تعديل على أي طريقة دفع وتمويل أو على توفير خدمات تمارا. وأنت تدرك أنّ هذا معناه أننا في ظروف معينة، كأن يتعذر علينا منحك ائتمانًا بخصوص معاملة معينة (لأي سبب)؛ يجوز أن نخصم كامل قيمة المعاملة من البطاقة المسجلة الخاصة بك.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٠.</strong> توفر تمارا خدمات الدفع الإلكتروني من خلال مزودي خدمة خارجيين. ولا تتحمل تمارا أية مسؤولية عن أي خطأ أو ضرر أو أي خسارة قد تتعرض لها نتيجة استخدام طريقة الدفع الإلكترونية، إذ يقع ذلك ضمن نطاق مسؤولية مزود الخدمة الخارجي.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١١.</strong> يجب عليك التأكد من أن لديك أموالاً كافية في حساب تمارا الخاص بك (عبر البطاقة المسجلة الخاصة بك) قبل تقديم طلب الشراء أو محاولة إتمام المعاملة. فأنت وحدك المسؤول عن الامتثال لأي من حدود المعاملات المنطبقة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٢.</strong> أنت توافق بمُوجب هذه الشروط والأحكام على تفويض تمارا بسحب المبلغ ذي الصلة اللازم لإتمام معاملة من وسيلة الدفع المخزنة في حساب تمارا الخاص بك في تاريخ استحقاق الدفع. وإذا رُفضت معاملة بسبب نقص الأموال التي تغطي القسط، فستُجرَى محاولة لخصم هذه الأموال تلقائيًا كل يومين (2) إلى حين دفع المبلغ بالكامل. وتحتفظ تمارا بحقها في إحالة قضيتك إلى أية وكالة تحصيل ذات صلة و/أو مشاركة بياناتك مع أية جهات تنظيمية ذات صلة؛ وفقًا لتقديرها المطلق.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٣.</strong> أنت تتعهد وتقر بموجب هذه الشروط والأحكام بأنّ لديك أن لديك أموالاً كافية متاحة للوفاء بأي التزامات مالية تجاه تمارا حسب الاقتضاء من وقت لآخر. ولتمارا الحق في التعاون مع التجار ذوي الصلة في حالة عدم وفائك بالتزاماتك بدفع أية مبالغ مستحقة ومتأخرة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٤.</strong> أنت توافق بموجب هذه الشروط والأحكام على تفهمك وتحملك للعواقب المحتملة عند استخدام خدمات تمارا خلافاً للشروط المتفق عليها.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٥.</strong> أنت توافق على أحقية تمارا − حسب تقديرها المطلق − بإخطار السلطات أو الجهات التنظيمية المعنية في حالة تأخرك أو عجزك عن السداد أو إذا قمت بأي نشاط مشتبه به.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٦</strong> أنت تقر وتوافق بموجب هذه الشروط والأحكام على أنّه يجوز لتمارا (لأغراض فحوصات العملاء النافية للجهالة) أن تقدم بياناتك − من وقت لآخر − إلى الوكالات الائتمانية ذات الصلة لكي تُعدَّ تقريرًا ائتمانيًا عن سجلك الائتماني وملاءتك الائتمانية. فإذا جاء التقرير الائتماني سلبيًا، فإنك تقر بأن لتمارا الحق في تقييد وصولك إلى خدمات تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٧.</strong> أنت توافق بمُوجب هذه الشروط والأحكام على أنّك المستفيد الحقيقي من خدمات تمارا وأنّك لا تستخدم خدمات تمارا في أي عمليات غسل أموال أو أنشطة غير نظامية أخرى.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٨.</strong> أنت تدرك بأننا إذا علمنا بأي غش أو احتيال فعلي أو مشتبه به يتعلق بانتفاعك من خدمات تمارا خصوصًا أو حساب تمارا الخاص بك عمومًا، فإن لدينا الحق في أن نخصم أموالاً من حساب تمارا الخاص بك أو نفرض عليه رسومًا أو نحاسبك بطريقة أخرى (حسب الاقتضاء)، ومن ذلك: (أ) حجب أو تأخير ردّ أي استرداد للأموال، أو (ب) احتجاز أية رسوم تدفعها (من خلال حساب تمارا أو غير ذلك)، أو (ج) مطالبتك بأن تدفع فورًا المبلغ الإجمالي المتبقي من الأقساط المتأخرة (حسب الاقتضاء) فيما يتعلق بأي معاملة ذات صلة، وذلك إلى أن نقرر − وفق تقديرنا المطلق − بأن المعاملة لم تتضمن أي غش أو احتيال.',
  },
  {
    type: 'subtitle',
    content: '١١. استرداد المدفوعات',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١.</strong> تمارا غير مسؤولة عن أي قرار يتخذه التاجر أو منصة التاجر بشأن استرداد الأموال − حسب الاقتضاء − بينك وبين التاجر أو منصة التاجر، إلا ما يكون متعلقًا ببرنامج تمارا لحماية المشتري. ومع ذلك، يجوز لتمارا أن تقوم بدور في تسهيل عمليات استرداد الأموال هذه وفقًا لتقديرها المطلق، شريطة ألا ينطوي هذا الدور على أية مسؤولية فيما يتعلق بأي استرداد للأموال.',
  },
  {
    type: 'subtitle',
    content: ' ١٢. شروط إضافية خاصة',
  },
  {
    type: 'text',
    content:
      '<strong>١٢.١.</strong> قد تنطبق شروط وأحكام أخرى بينك كعميل وبين تمارا، ويكون انطباق مثل هذه الشروط موقوفًا على كيفية استخدامك لتطبيق الجوال والموقع الإلكتروني وخدمات تمارا ذات الصلة. ويمكن الاطلاع على هذه الشروط في الموقع الإلكتروني، وهي تتعلق بما يلي:',
  },
  {
    type: 'text',
    content: '<strong>١٢.٢.</strong> برنامج فرح.',
  },
  {
    type: 'text',
    content: '<strong>١٢.٣.</strong> برنامج تمارا لحماية المشتري،',
  },
  {
    type: 'text',
    content: 'كلٌ حسب الاقتضاء في جميع الأوقات.',
  },
  {
    type: 'subtitle',
    content: 'القسم الثالث - الشروط العامة',
  },
  {
    type: 'subtitle',
    content: '١٣. السرية والخصوصية',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.١.</strong> تلتزم تمارا بالحفاظ على سرّية المعلومات والمعلومات الائتمانية التي بحوزتها.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٢.</strong> بالإضافة إلى الالتزامات المبينة في البند (5) أعلاه، أنت توافق بموجب هذه الشروط والأحكام على تقديم أيّة معلومات، ومن ذلك بمعلومات التعريف أو وثائقها التي تطلبها تمارا بشكل معقول للتحقق من هويتك فيما يتعلق بحساب تمارا الخاص بك أو أي استخدام لخدمات تمارا، كما تفوضنا بإجراء أي استفسارات نرى أنها ضرورية من أجل التحقق من هويتك. وتحتفظ تمارا بحقّها في إغلاق حساب تمارا الخاص بك أو إيقاف أو تقييد وصولك إلى خدمات تمارا إذا لم نتمكن من الحصول على أيٍّ من هذه المعلومات أو التحقق منها بما يرضينا.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٣.</strong> أنت توافق بموجب هذه الشروط والأحكام وتفوض تمارا لاستخدام أي من أو جميع بيانات التعريف الشخصي والبيانات الشخصية الخاصة بك التي جُمعت من خلال الموقع الإلكتروني أو تطبيق الجوال، أو من خلال التجار أو منصة التاجر من وقتٍ لآخر، ويجوز استخدامها أو الإفصاح عنها إلى أشخاص آخرين إذا كانوا بحاجة إلى معرفتها وذلك وفق سند نظامي صحيح دائماً. وقد يشمل ذلك مشاركة بيانات التعريف الشخصي الخاصة بك وأية معلومات أخرى مع جهات خارجية لأغراض التحقق من الائتمان ومكافحة غسل الأموال أو غيرها من الفحوصات المماثلة أو لأي غرض آخر تعتبره تمارا ضروريًا من أجل تمكين تمارا من تقديم خدمات تمارا والالتزام بجميع الأنظمة السارية.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٤.</strong> أنت توافق بموجب هذه الشروط والأحكام على هذه الشروط والأحكام عند الوصول إلى الموقع الإلكتروني أو تطبيق الجوال، كما توافق على سياسة الخصوصية المعمول بها لدينا، ومدركاً بأننا نجمع معلوماتك الشخصية وتفهم كيف سيتعامل معها.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٥.</strong> إذا كنت لا توافق على سياساتنا وممارساتنا، فلن تتمكن من استخدام الموقع الإلكتروني أو تطبيق الجوال، ونرجو عدم الاستمرار في استخدام خدمات تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٦.</strong> يحق لك سحب موافقتك على معالجة بياناتك الشخصية في أي وقت، وفقًا للقيود التعاقدية والنظامية ومع تقديم إخطار خطي بذلك.',
  },
  {
    type: 'text',
    content:
      '<strong>١٣.٧.</strong> لا يجوز الإفصاح للغير عن أيّة معلومات تتلقاها بموجب هذه الشروط والأحكام أو أي عقد آخر مبرم مع تمارا. ويجب الوصول بسرّية إلى أيّة معلومات تتعلق بأعمال تمارا، وتكون أنت المسؤول عن تعويض تمارا عن أية خسارة في العمل أو السمعة، إذا حدث ذلك نتيجة لأي فعل ناتج عن وصولك إلى تلك المعلومات.',
  },
  {
    type: 'subtitle',
    content: '١٤. حدود المسؤولية',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.١.</strong> تمارا مزود خدمة مستقل وليست طرفًا في أي ترتيبات مباشرة بين العملاء والتجار أو أي جهات خارجية أخرى ذات صلة. فلا تكون تمارا مسؤولة بأي حال من الأحوال (بخلاف مسؤوليتها عن التزاماتها بموجب برنامج تمارا لحماية المشتري) عن أي مطالبة أو منازعة تُنسَب إلى التجار، كما لا تكون مسؤولة عن أي حالات إخفاق تتعلق بعلامة مُنتَجات أو خدمات التجار أو موثوقيتها أو كفايتها أو أصالتها أو توافرها أو نظاميتها، أو عن أية أضرار تكون ناجمة عن ذلك.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٢.</strong> التجار الخارجيون هم مقدمو خدمة مستقلون لا يخضعون لهذه الشروط والأحكام ولا يلتزمون إلا بتعاقداتهم المبرمة مع تمارا. فلا يُعَدّ التجار موظفين أو ممثلين أو وكلاء لتمارا. ويتحمل التجار المسؤولية الكاملة عن جميع المعاملات التي تتم بينهم وبين العملاء أو المعاملات الأخرى ذات الصلة. وإذا كانت هناك منازعة بينك وبين أي تاجر أو جهة خارجية، فإنّك تتعهد بإبراء ذمة تمارا من أية مسؤولية تنشأ عن هذه المنازعات أو تتعلق بها. ويكون هذا التعهد بمثابة إعفاء لتمارا (ووكلائها وموظفيها) من المطالبات والطلبات والالتزامات والتعويضات أيًا كان نوعتها وطبيعتها، وسواء كانت معروفة أو غير معروفة، مُفصَح عنها أو غير مُفصَح عنها؛ التي تنشأ عن هذه المنازعات أو تتعلق بها بأي شكل من الأشكال.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٣.</strong> إذا وافقت على هذه الشروط والأحكام، فإنك بذلك تقر بإمكانية حدوث مخاطر أو أخطاء من التجار أو أي من مزودي الخدمات الخارجيين. لذا، تكون أنت وحدك المسؤول عن استخدام خدمات تمارا، ولا تتحمل تمارا أية مسؤولية تجاه استخدامك لها.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٤.</strong> لا تكون تمارا مسؤولة تجاهك أو تجاه أي شخص آخر عن أية أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو جزائية أو عقابية أو تبعية قد تنشأ، حتى لو جرى إبلاغ تمارا بإمكانية حدوث مثل هذه الأضرار، ولا تكون تمارا كذلك مسؤولة عن أية أضرار أو التزامات أو خسائر تتكبدها نتيجة استخدامك للخدمات أو اعتمادك عليها، أو نتيجة لعدم قدرتك على الوصول إلى خدمات تمارا أو استخدامها، أو نتيجة أي معاملة أو علاقة نشأت بينك وبين التاجر، حتى لو كانت تمارا على علم بإمكانية حدوث مثل هذه الأضرار. علاوة على ذلك، لا تكون تمارا مسؤولة عن أي تأخير أو تقصير في التنفيذ، ولا تتحمل المسؤولية في حالة عدم حصول التاجر على التراخيص والتصاريح المناسبة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٥.</strong> تُقَدَّم الخدمات على أساس "حالتها الراهنة"، وتُخلِي تمارا مسؤوليتها عن جميع الإقرارات والتعهدات الصريحة أو الضمنية أو النظامية التي لم تُذكَر صراحةً في هذه الشروط والأحكام، ومن ذلك التعهدات الضمنية المتعلقة بقدرة البائع ومدى ملاءمة سلعه أو خدماته لغرض معين، وذلك إلى أقصى حد يجيزه النظام. ولا تُقَدِّم تمارا أي إقرار أو تعهد حول الموثوقية أو الجودة أو الاستدامة أو التوفر أو المالك الأصلي للسلع أو الخدمات أو أية خدمات تُطلَب من خلال استخدام خدمات تمارا، ولا تضمن تمارا عدم انقطاع الخدمات أو خلوها من الأخطاء. وأنت تقرّ وتوافق بمُوجب هذه الشروط والأحكام على أنّك تتحمل جميع المسؤوليات الناشئة عن استخدامك لأيٍّ من خدمات تمارا، وذلك إلى أقصى حد تجيزه الأنظمة السارية.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٦.</strong> لا نوفِّر المعلومات الموجودة على الموقع الإلكتروني وتطبيق الجوال إلا للأغراض العامة فقط. وتبذل تمارا جهودًا معقولة لإبقاء المعلومات مُحَدَّثَة وصحيحة، ولكنها لا تقدم أية إقرارات أو تعهدات من أي نوع، سواء أكانت صريحة أم ضمنية، من حيث اكتمال أو دقة أو موثوقية أو ملاءمة أو توفر الموقع الإلكتروني أو تطبيق الجوال أو المعلومات أو الخدمات أو الإعلانات أو الرسومات ذات الصلة الموجودة على الموقع الإلكتروني أو تطبيق الجوال لأي غرض، وبالتالي يجب عليك الاعتماد على هذه المعلومات على مسؤوليتك الخاصة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٧.</strong> تُراقَب جميع حسابات تمارا بانتظام لأسباب تتعلق بالأمان والأداء.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٨.</strong> لا تتحمل تمارا المسؤولية عن أي تأخير أو انقطاع أو فشل في تقديم خدمات تمارا بسبب حدث قوة قاهرة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٤.٩.</strong> إذا كنت لا توافق على أي بند من هذه الشروط والأحكام، فلا يجوز لك الوصول إلى الموقع الإلكتروني أو تطبيق الجوال، ولا استخدام خدمات تمارا.',
  },
  {
    type: 'subtitle',
    content: '١٥. التصرف في الحقوق',
  },
  {
    type: 'text',
    content:
      '<strong>١٥.١.</strong> يشكل هذا البند إخطارًا لك بأنه يجوز لنا رهن جميع حقوقنا وملكيتنا ومصالحنا بموجب هذه الشروط والأحكام وعلى النحو الوارد فيها، ومن ذلك الحق في الحصول على أي مبلغ مستحق الدفع من قبلك وفقًا لهذه الشروط والأحكام؛ إلى طرف ثالث مستفيد والذي سيكون مستحقاً للحقوق والمنافع بموجب هذه الشروط والأحكام ويجوز له إنفاذ أحكام هذه الشروط والأحكام كما لو كان طرفًا فيها. سيبقى لتمارا الحق في ممارسة جميع حقوقها وصلاحياتها وسلطاتها التقديرية وسبل الانتصاف المتاحة لها بموجب هذه الشروط والأحكام، ويجب عليك الالتزام بالدفع لنا أي مبلغ مستحق الدفع من قبلك وفقًا لهذه الشروط والأحكام وموافاتنا بالإخطارات المطلوبة بموجبها، ما لم تتلق إخطارًا خطيًا بخلاف ذلك.',
  },
  {
    type: 'subtitle',
    content: ' ١٦. التعويض',
  },
  {
    type: 'text',
    content:
      '<strong>١٦.١.</strong> أنت تقرّ وتوافق على تعويض تمارا ودرء الضرر عنها هي وما يتبعها من شركات وكيانات وجهات راعية وشركاء وإدارات وموظفين وسداد جميع الخسائر التي تكبدتها وكذلك قيمة الأضرار والالتزامات والمطالبات والأحكام والتسويات والغرامات والتكاليف والنفقات (ومن ذلك أيّة مصاريف وأتعاب نظامية وتكاليف تحقيق وأتعاب محاماة)، وذلك إذا تعرضت تمارا لأية أضرار تسببت أنت بها أو إذا نَشَأَت أو كانت مرتبطة بقيامك بخرق هذه الشروط والأحكام أو سياسة الخصوصية أو استخدامك أو استخدام طرف ثالث (مفوض من قبلك) لخدمات تمارا.',
  },
  {
    type: 'subtitle',
    content: ' ١٧. الإخطارات',
  },
  {
    type: 'text',
    content:
      '<strong>١٧.١.</strong> يجب أن تكون جميع الإخطارات والمراسلات الأخرى بمُوجِب هذه الشروط والأحكام خطية وأن تُرسل إلى بريد تمارا الإلكتروني المعروض على الموقع الإلكتروني.',
  },
  {
    type: 'subtitle',
    content: ' ١٨. أحكام عامة',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.١.</strong> تخضع حقوق والتزامات الطرفين الواردة في هذه الشروط والأحكام لأنظمة الإمارات العربية المتحدة وتُفَسَّر وفقًا لها.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٢.</strong> إذا وافقت على هذه الشروط والأحكام، فإنك بذلك تتعهد بالخضوع دون قيد أو شرط للاختصاص القضائي الحصري لمحاكم الإمارات العربية المتحدة فيما يتعلق بأي إجراءات نظامية ناشئة عن أو متعلقة بهذه الشروط والأحكام، أو العلاقات النظامية التي نشأت عنها، أو الموضوعات المختلفة الواردة هنا في هذه الشروط والأحكام. ويتنازل الطرفان بمُوجِبه ويوافقان على عدم التأكيد (عن طريق رفع طلب أو مذكرة دفاع أو غير ذلك) على أن أي إجراء مماثل قد اتُّخِذَ في محكمة غير ملائمة أو لدى مَقَرّ غير مناسب.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٣.</strong> أنت توافق بموجب هذه الشروط والأحكام على التعاون مع تمارا إلى أقصى حد تجيزه الأنظمة السارية، ومن ذلك الموافقة على الإجابة خطيًا على أي أسئلة أو تقديم معلومات لمساعدة تمارا في إجراء أي تحقيق أو استعلام داخلي.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٤.</strong> أنت تقر بموجب هذه الشروط والأحكام بأن تمارا يجوز لها الإفصاح عن أي معلومات عنك وعن حسابك المذكور آنفًا أو أي حساب آخر لأي جهات تنظيمية بمُوجِب الأنظمة السارية وأي قواعد لاتحاد البطاقات المصرفية تكون سارية من وقت لآخر، و/أو الممثل المعتَمَد للجهات التنظيمية ذات الصّلة، بما في ذلك − على سبيل المثال لا الحصر – أي وكالة ائتمانية من خلال اتفاقية العضوية المبرمة وقواعد العمل المعتمدة لتبادل المعلومات، و/أو مع أي طرف آخر على نحو ما تعتمده الجهة التنظيمية المختصة أو أية مؤسسة مالية محلية أخرى ذات صلة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٥.</strong> إذا تأخرت في سداد أية مدفوعات مستحقة لنا، فيجوز لنا عندئذ تقديم تفاصيل تأخرك أو تقاعسك عن السداد للوكالات الائتمانية المكلفة من قبل تمارا من وقت لآخر، ويجوز لهذه الوكالات تحديث سجلك الائتماني وفقًا لما يردها من تلك التفاصيل. وقد يؤثر ذلك على تصنيفك الائتماني، ويجعل حصولك على التسهيلات الائتمانية أصعب وأعلى تكلفةً في المستقبل.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٦.</strong> إذا تقرر انعدام صلاحية أو نفاذ أو سريان أيَّ شرط أو حكم من هذه الشروط والأحكام، عندئذ يكون هذا الشرط أو الحكم هو وحده الذي يُعتبر غير سارٍ دونما تأثيرٍ بأي شكل على بقية هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٧.</strong> تصبح هذه الشروط والأحكام سارية في التاريخ الذي تدخل فيه إلى الموقع الإلكتروني أو تطبيق الجوال و/أو في التاريخ الذي تبدي فيه موافقتك عبر إنشاء حساب تمارا، وتظل سارية إلى حين إلغائها أو إبطالها من قبل تمارا وفقًا لتقديرها الكامل.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٨.</strong> إذا اختارت تمارا − وفقًا لتقديرها المطلق − إلغاء تنشيط وصولك إلى حساب تمارا الخاص بك، وبالتالي إلغاء هذه الشروط والأحكام، فسوف تخطرك تمارا بذلك عن طريق إرسال إخطار إلى عنوان البريد الإلكتروني الذي قدمته إلى تمارا. وأنت تقر وتوافق بموجب هذه الشروط والأحكام على أن لتمارا الحق المطلق في إلغاء هذه الشروط والأحكام بسبب أو دون سبب، وليس عليها أي التزام بإخطارك بسبب إلغاء هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٩.</strong> إذا أغلقت حساب تمارا الخاص بك باتّباع الإرشادات الموجودة على الموقع الإلكتروني أو تطبيق الجوال، عندئذ يتوقف سريان هذه الشروط والأحكام. وتجنّبًا للشك، ستظل مسؤولاً عن جميع الالتزامات المتعلقة بحساب تمارا الخاص بك وجميع المبالغ المتأخرة عليك لصالح تمارا حتى بعد إغلاق حساب تمارا الخاص بك و/أو إيقاف سريان هذه الشروط والأحكام.',
  },
  {
    type: 'subtitle',
    content: ' ١٩. كامل الاتفاق',
  },
  {
    type: 'text',
    content:
      '<strong>١٩.١.</strong>  تمثل هذه الشروط والأحكام، إلى جانب سياسة الخصوصية وأي شروط أخرى متفق عليها بينك وبين تمارا من وقت لآخر؛ مجمل ما جرى الاتفاق عليه فيما بينك وبين تمارا.',
  },
  {
    type: 'subtitle',
    content: '٢٠. الشكاوى',
  },
  {
    type: 'text',
    content:
      '<strong>٢٠.١.</strong>  نحن ملتزمون بأن نقدم لعملائنا خدماتٍ على أعلى مستوى من الجودة والتميز، لذلك نقدر ما يردنا من عملائنا من تعقيبات أعظم التقدير إذ نستفيد منها في تحسين خدماتنا باستمرار. فإذا وجدت أنك لا تتلقى خدمة عملاء مميزة وذات جودة عالية، أو أن ثمة جانبٌ من الخدمة يحتاج إلى تحسين؛ يُرجى إبلاغنا بذلك.',
  },
  {
    type: 'text',
    content:
      '<strong>٢٠.٢.</strong>  إذا كنا لم نحقق معايير الجودة الممتازة التي وضعناها لأنفسنا، فلشد ما نريده حينئذ أن تُتاح لنا الفرصة لتصحيح الأمور، ومع ذلك نقرُّ بأنّه أحيانًا قد لا تسير الأمور كما ينبغي، وربما تقع أخطاء. وإذا حدث ذلك، فإننا ملتزمون بعلاج هذه الأخطاء بسرعةٍ وبإنصاف. إذا كنت ترغب في تقديم شكوى؛ يمكنك التواصل معنا من خلال مركز مساعدة العملاء لدى تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٢٠.٣.</strong>  فور استلامنا لشكواك، سنتخذ الإجراءات التالية: (1) إرسال إقرار خطي عن الشكوى في غضون عشرة (10) أيام عمل، أو أي فترة تجيزيها الأنظمة السارية، أيهما ياتي لاحقاً؛ من تاريخ استلامها ومن ثم إبلاغك بأي تفاصيل ناقصة، و(2) التحقيق في المخاوف وترتيب مناقشة معك لمحاولة الاتفاق على كيفية حل المشكلات، و(3) الرد بقرارنا النهائي بشأن هذه المسألة، وتحديد نتيجة تحقيقنا وأي مقترحات لتصحيح الأمر أو حله، وذلك في غضون عشرة (10) أيام عمل، أو أي فترة تجيزيها الأنظمة السارية، أيهما يأتي لاحقاً؛ من تاريخ تلقي شكواك الكاملة، و(4) تذكيرك بأنه قد يحق لك إحالة شكواك إلى الجهة التنظيمية المختصة وتقديم التفاصيل المتعلقة بفعل ذلك في نهاية إجراءاتنا للتعامل مع الشكوى.',
  },
  {
    type: 'subtitle',
    content: '٢١. الأخطاء',
  },
  {
    type: 'text',
    content:
      '<strong>٢١.١.</strong>  إذا علمنا بوجود أي خطأ أو عطل في حساب تمارا الخاص بك، سنتّخذ الإجراءات التالية: (1) الإعادة الفورية لأي مبالغ جرى تحصيلها نتيجة لهذا الخطأ، حسب الاقتضاء، و(2) معالجة هذه الأخطاء وتصحيحها لأي عملاء متضررين في غضون ستين (60) يوم عمل، أو أي فترة تجيزها الأنظمة السارية، أيهما يأتي لاحقاً؛ اعتبارًا من تاريخ تحديد الخطأ، و(3) إبلاغك بهذا الخطأ واتخاذ الإجراءات التصحيحية.',
  },
  {
    type: 'subtitle',
    content: 'القسم الرابع - التعريفات',
  },
  {
    type: 'text',
    content:
      '٢٢. تحمل الإشارات والكلمات والعبارات والمصطلحات التالية المعاني الموضحة أمام كل منها في هذه الشروط والأحكام:',
  },
  {
    type: 'text',
    content:
      '<strong>الأنظمة السارية:</strong> يُقصد بها أية أنظمة ولوائح سارية تخضع لها تمارا و/أو العميل، ومن ذلك مثلاً أي قواعد لاتحاد البطاقات المصرفية تكون سارية من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>العميل:</strong> يُقصد به عميل التاجر أو منصة التاجر الذي ينشئ حساب تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>المنازعة:</strong> يُقصد بها أي طلب رد أموال أو خصم أو تعويض أو مطالبة مضادة أو أي منازعة من أي نوع يقيمها العميل ضد التاجر فيما يتعلق بالسلع أو الخدمات التي نتجت عنها معاملة معتمدة.',
  },
  {
    type: 'text',
    content:
      '<strong>برنامج فرح:</strong> يُقصد به خدمة مكافآت حصرية تقدمها تمارا تسمح لك بتحصيل بعض المكافآت أو الخصومات أو العروض الأخرى المتاحة (المشار إليها من قبل تمارا باسم "فرح") واستردادها من خلال تطبيق الجوال. يمكنك الاطلاع على شروط وأحكام برنامج في الموقع الإلكتروني.',
  },
  {
    type: 'text',
    content:
      '<strong>القوة القاهرة:</strong> تعني أي سبب خارج عن الإرادة والسيطرة المعقولة لأي طرف، مما يؤثر على أداء التزاماته بموجب هذه الشروط والأحكام، ويشمل على سبيل المثال لا الحصر الحريق والفيضان والحوادث والحرب والإضراب والحظر الاقتصادي والعمليات العسكرية أو المتطلبات والتعليمات النظامية.',
  },
  {
    type: 'text',
    content:
      '<strong>معلومات التعريف:</strong> يُقصد بها المعلومات المطلوبة التي يجب أن يقدمها العميل إلى تمارا لإنشاء حساب له مع تمارا، والتي تجمعها تمارا أو التاجر أو منصة التاجر لأغراض تقديم خدمات تمارا للعملاء.',
  },
  {
    type: 'text',
    content:
      '<strong>حقوق الملكية الفكرية:</strong> يُقصد بها أي من براءات الاختراع، والنماذج النفعية، وحقوق الابتكار، وحقوق الطبع والنشر والحقوق المرتبطة بذلك، والعلامات التجارية، وعلامات الخدمة، والأسماء التجارية، وأسماء النطاقات، وحقوق الاستحواذ والسمعة الحسنة والحق في رفع دعوى نتيجة البيع بالخِداع والتَّضليل أو المنافسة غير العادلة، والحقوق في التصميم، والحقوق في برامج الكمبيوتر، وحقوق قاعدة البيانات، وحقوق الحفاظ على سرية المعلومات السرية (بما في ذلك الدراية الفنية والأسرار التجارية)، وأي من حقوق الملكية الفكرية الأخرى، بما في ذلك جميع طلبات هذه الحقوق (وحقوق التقدم للحصول علي هذه الحقوق واستمناحها)، والتجديدات أو التمديدات المتعلقة بهذه الحقوق، وحقوق المطالبة بالتمتع بالأولوية في هذه الحقوق وجميع الحقوق المماثلة أو المكافئة أو أشكال الحماية القائمة أو التي ستبقى، الآن أو في المستقبل، في أي جزء من العالم.',
  },
  {
    type: 'text',
    content:
      '<strong>منصة التاجر:</strong> يُقصد بها وسائل تتيح لعدة تجار تقديم السلع والخدمات للعملاء من خلال منصة واحدة، ومن ضمنها مثلاً المواقع الإلكترونية والتطبيقات.',
  },
  {
    type: 'text',
    content:
      '<strong>التاجر:</strong> يُقصد به أي شخص يسمح لعملائه باستخدام خدمات تمارا وفقًا لاتفاقية مستقلة؛ حسب ما يُستَجَدّ من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>تطبيق الجوال:</strong> يُقصد به تطبيق تمارا للجوّال المتاح للتنزيل من المتاجر الرقمية ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>المبلغ الصافي:</strong> يُقصد به المبلغ الإجمالي الذي يتعين على العميل دفعه، ومن ذلك − حسب الاقتضاء − أي ضريبة قيمة مضافة ورسوم شحن تتعلق بطلب الشراء الذي يؤدي إلى معاملة واحدة معتمدة بعد خصم ما يلي: (1) أي استرداد الأموال، و(2) أي خصومات أو ائتمانات أو تخفيضات يطالب بها العميل ويوافق عليها التاجر ذو الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>طلب الشراء:</strong> يُقصد به الطلب المقدم من العميل من خلال منصة التاجر أو الموقع الإلكتروني أو تطبيق الجوال أو موقع التاجر الإلكتروني أو أي تطبيقات أو نقاط بيع أخرى لاستخدام خدمات تمارا لشراء سلع أو خدمات من التاجر ذي الصلة أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>استرداد الأموال:</strong> يُقصد بها المبلغ (الذي ربما يكون متنازعًا عليه) والذي يكون العميل قد دفعه إلى تاجر باستخدام خدمات تمارا فيما يتعلق بمعاملة معتمدة، ثم يُرد لاحقًا إلى العميل بعد تسوية هذه المنازعة.',
  },
  {
    type: 'text',
    content:
      '<strong>حساب تمارا:</strong> يُقصد به الحساب الذي أنشأه العميل لاستخدام خدمات تمارا، والذي سيخضع استخدامه وتشغيله لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>خدمات تمارا:</strong> يُقصد بها خدمات الدفع والتمويل التي تقدمها تمارا، وفق ما يُستَجَدّ من وقت لآخر، والتي يختارها العميل على موقع التاجر الإلكتروني أو منصة التاجر أو في أي نقطة بيع أخرى لدى التاجر أو على منصة التاجر، ويختار بمُوجِبها شراء السلع أو الخدمات من التاجر أو منصة التاجر باستخدام خدمات تمارا وفقًا لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>برنامج تمارا لحماية المشتري:</strong> يُقصد به نظام يخضع للتعديل من وقت لآخر ويمكنك كعميل من خلاله، بعد فوزك بأي مطالبة، أن تسترد المبلغ الصافي بالكامل (وهو كامل سعر شراء السلع أو الخدمات ذات الصلة التي قدمها التاجر ذو الصلة أو قدمتها منصة التاجر ذات الصلة، بالإضافة إلى أية تكاليف شحن أصلية تكون قد دُفعت، حسب الاقتضاء، والتي تكون قد اشتريتها باستخدام خدمات تمارا). ويمكن الاطلاع على شروط وأحكام برنامج حماية المشتري وعلى مزيد من المعلومات في قسم الأسئلة الشائعة في الموقع الإلكتروني.',
  },
  {
    type: 'text',
    content:
      '<strong>الشروط والأحكام</strong> يُقصد بها شروط وأحكام العميل هذه بصيغتها المعدلة من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>المعاملة:</strong> يُقصد بها الطلب المقدم عبر حساب تمارا الخاص بك بناءً على طلب شراء للاستفادة من خدمات تمارا من أجل إكمال طلب الشراء هذا وتسويته مع التاجر ذي الصلة أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>بيانات المعاملة:</strong> يُقصد بها جميع البيانات المتعلقة بطلب الشراء والمعاملة.',
  },
  {
    type: 'text',
    content:
      '<strong>نحن:</strong> الإشارات إلى ضمير المتكلم المنفصل "نحن" أو ضمير المتكلم المتصل "نا" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى تمارا والكيانات والأشخاص التابعين لها.',
  },
  {
    type: 'text',
    content:
      '<strong>الموقع الإلكتروني:</strong> يُقصد به موقع تمارا الإلكتروني ورابطه هو: <a href="https://tamara.co" target="_blank">https://tamara.co</a>.',
  },
  {
    type: 'text',
    content:
      '<strong>أنت:</strong> الإشارات إلى ضمير المُخاطَب المنفصل "أنت" أو المُخاطَب المتصل "ــك" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى العميل ذي الصلة المشار إليه في معلومات التعريف التي يجب تقديمها قبل استخدام خدمات تمارا.',
  },
]
